import _ from 'lodash';
import React from 'react';

import TextBox from '../../../../ui/TextBox';
import Date from '../../../../ui/Date';
import CheckBox from '../../../../ui/CheckBox';

import { ApplicableTableSettings, mblSelectContainer } from '../../../../tableSettings';

import SmartTable from '../../../../uiControls/SmartTable';

import MblMilestoneContainerStatus from './MblMilestoneContainerStatus';
import { OiMbl } from '../../../../fms.core/OiMbl';
import { OceanMblStatusMap } from '../../../../fms.core/MblStatusViewModel';
import { OmContainer } from '../../../../fms.core/OmContainer';
import { PimsCntrEvent } from '../../../../fms.core/PimsCntrEvent';
import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import BlueTitleRow from '../../../../ui/BlueTitleRow';
import { TextAlignLeftRenderer } from '../../../../uiControls/SmartTableRenderers';
import { getOriginalValue } from '../../../../fms.core/data/TrackingModule';
import { useHistory } from 'react-router';

// function MilestoneStatusRow({left, middle, right}:{left:React.ReactNode|string|null|undefined, middle:React.ReactNode|string|null|undefined, right:React.ReactNode|string|null|undefined}) {
//   return (
//     <>
//       <InputControlRow nolabel>
//         {/* <div style={{float: 'left', width: 'calc(30% - 20px)', marginRight: '20px'}}>{left}</div> */}
//         <div style={{float: 'left', width: '50%'}}>{middle}</div>
//         <div style={{float: 'left', width: 'calc(49% - 20px)', marginLeft: '20px'}}>{right}</div>
//       </InputControlRow>
//       <div style={{clear: 'both'}}></div>
//     </>
//   );
// }

function SelectRenderer({data, row}:any) {
  const toggleSelection = data[0].toggleSelection;
  const selectedIndex = data[0].selectedIndex;
  const isView = data[0].isView;

  return <div className="ifms-table-default"><CheckBox name={`container-status-table-check-${row.index}`} value={selectedIndex === row.index} onChange={() => toggleSelection(row.index)} disabled={isView} /></div>;
}

export type OiMblMilestoneHandle = {
  executeApplyToAll: VoidFunction,
};

type MblMilestoneProps = {
  mbl: OiMbl,   //[save-sqlinfo]:OceanImportMbl,
  onChange: (x:Partial<OiMbl>) => void,     //[save-sqlinfo]:(x:Partial<OceanImportMbl>) => void,
  containerInfo: OmContainer[], 
  onContainerInfoChange: (x:OmContainer[]) => void,    
  isView: boolean,
  user: string,
};

const MblMilestoneImpl: React.ForwardRefRenderFunction<OiMblMilestoneHandle, MblMilestoneProps> =({
  mbl,
  onChange,
  containerInfo,
  onContainerInfoChange,
  isView,
  user
}, ref) => {
  React.useImperativeHandle(ref, () => ({
    executeApplyToAll: () => {
      const status = selectedIndex >= 0 && selectedIndex < containerInfo.length ? mbl.milestone?.eventItemList?.filter(v => v.cntrNo === containerInfo[selectedIndex].containerNo || (v.pimsCntrId > 0 && v.pimsCntrId === containerInfo[selectedIndex].pimsLinkId))??null : null;
      if (status && status.filter(x => x.datetime !== null ).length > 0) {
        applyContainerStatusToAll(status);
      }
    },
  }));

  const history = useHistory();
  const isOtherShipment = history.location.pathname.includes('otherShipment');

  const selectedIndex = mbl.milestoneContainerSelectedIndex ?? 0;
  function setSelectedIndex(milestoneContainerSelectedIndex:number) {
    onChange({ milestoneContainerSelectedIndex });
  }

  function toggleSelection(index:number) {
    setSelectedIndex(selectedIndex === index ? -1 : index);
  }

  /**
   * Update OmContainer's props at rowIndex by status
   * @param rowIndex index of container list
   * @param status 
   */
  function onContainerStatusChange(cntrIndex:number, 
    status: Array<PimsCntrEvent>, select: boolean) {

    const update = _.cloneDeep(containerInfo);
    //<save-sqlinfo:
    //update.lineItems[rowIndex].milestone.status = status;
    // Find target CmContainer's event with same name and update it
    status.forEach(s => {
      const omCntr = update[cntrIndex];

      const pimsCntr = mbl.milestone?.cntrItemList.find(x => x.cntrNo === s.cntrNo || (x.id > 0 && x.id === s.pimsCntrId)); 
      const msitem = OceanMblStatusMap.get(s.seq);

      if (msitem?.cntrDate) {
        const cntrDateToSet = !select ? getOriginalValue(mbl.oimContainerList[cntrIndex], msitem.cntrDate) : s.datetime;
        if (omCntr) _.set(omCntr, msitem.cntrDate, cntrDateToSet);
        if (pimsCntr && msitem.pimsCntrDate) _.set(pimsCntr, msitem.pimsCntrDate, cntrDateToSet);
      }
      
      if (msitem?.cntrLoc) {
        const locToSet = !select ? getOriginalValue(mbl.oimContainerList[cntrIndex],msitem.cntrLoc) : s.locName;
        if (omCntr) _.set(omCntr, msitem.cntrLoc, locToSet);
        if (pimsCntr && msitem.pimsCntrLoc) _.set(pimsCntr, msitem.pimsCntrLoc, locToSet);
      }
    });
    //save-sqlinfo>
    onContainerInfoChange(update);
  }

  function applyContainerStatusToAll(
    status:Array<PimsCntrEvent>) {
    const update = _.cloneDeep(containerInfo);

    // collect valid events

    const statusUpdateWithIndices = status.map((status, index) => ({status, index})).filter(s => s.status.datetime);

    const changeProps = update[selectedIndex].changedProps.map(x => x.propertyName);

    const updatedProps = _.keys(update[selectedIndex]).filter(x => (
        x.endsWith('Date') ||
        x.endsWith('Loc') ||
        x.endsWith('ord') ||
        x.endsWith('atd') ||
        x.endsWith('carrierRls') ||
        x.endsWith('customRls') ||
        x.endsWith('ata') ||
        x.endsWith('rAtd') ||
        x.endsWith('rAta') ||
        x.endsWith('emptyReturn')
      ) && !!(update[selectedIndex] as any)[x] && (changeProps.includes(x)));

    update.forEach((x, i) => {
      if (i === selectedIndex) {
        return;
      }

      updatedProps.forEach(u => {
        (x as any)[u] = (update[selectedIndex] as any)[u];
      });

      if (mbl.milestone && mbl.milestone.eventItemList) {

        const itemList = mbl.milestone.eventItemList.filter(v => v.cntrNo === x.containerNo || (v.pimsCntrId > 0 && v.pimsCntrId === x.pimsLinkId));

        statusUpdateWithIndices.forEach(si => {
          if (itemList.length > si.index) {
            itemList[si.index].check = si.status.check;
            itemList[si.index].date = si.status.date;
            itemList[si.index].datetime = si.status.datetime;
            itemList[si.index].time = si.status.time;
            itemList[si.index].locName = si.status.locName;
          }
        })
      }
    })

    onContainerInfoChange(update);
    setSelectedIndex(-1);
  }

  const pickupNo = mbl.oimContainerList && mbl.oimContainerList
    ? mbl.oimContainerList.filter(x => !!x.pickupNo).map(x => x.pickupNo).join(', ')
    : '';
  
  const tableOptions:ApplicableTableSettings = {
    tableName: 'oi-mblSelectContainer',
    ...mblSelectContainer,
    height: '135px',
    data: mbl.milestone?.cntrItemList?.map((x, i) => ({...x, i, toggleSelection, selectedIndex, isView})) || [],
    rowRenderers: [
      { accessor: 'select', Cell: SelectRenderer },
      { accessor: 'cntrNo', Cell: TextAlignLeftRenderer },
      { accessor: 'cntrType', Cell: TextAlignLeftRenderer },
    ],
  };

  return (
    <div>
      <div style={{display: 'flex'}}>
        <div style={{marginLeft: '40px', width: '190px'}}>
          <InlineInputControlRow label="MBL #" bold mode="w80">
            <TextBox name ='container-status-update-mblNo' disabled value={mbl.mblNo ?? ''} />
          </InlineInputControlRow>
        </div>
      </div>

      <div style={{marginTop: '10px'}}>
        <BlueTitleRow title={<span style={{paddingLeft: '14px'}}>Select Container (must select before update)</span>} />
      </div>

      <div style={{display: 'flex'}}>
        <div style={{display: 'flex', width: '310px'}}>
          <div style={{width: '230px'}}>
            <SmartTable {...tableOptions} />
          </div>
        </div>

        <div style={{marginLeft: '50px', width: '320px'}}>
          <InlineInputControlRow label="Loading Port" mode="smaller-2x">
            <TextBox name ='container-status-update-loadingPort' disabled value={mbl.loadingPort ?? ''} />
          </InlineInputControlRow>

          <InlineInputControlRow label="Discharge Port" mode="smaller-2x">
            <TextBox name ='container-status-update-dischargePort' disabled value={mbl.discharge ?? ''} />
          </InlineInputControlRow>

          <InlineInputControlRow label="ETA" mode="smaller-2x">
            <div style={{width: '80px'}}>
              <Date name ='container-status-update-eta' value={mbl.eta} disabled hideIcon />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="Delivery Port" mode="smaller-2x">
            <TextBox name ='container-status-update-deliveryPort' disabled value={mbl.finalDest ?? ''} />
          </InlineInputControlRow>

          <InlineInputControlRow label="Vessel Name" mode="smaller-2x">
            <TextBox name ='container-status-update-vesselName' disabled value={mbl.vessel ?? ''} />
          </InlineInputControlRow>

          {!isOtherShipment &&<InlineInputControlRow label="CNTR RTN Place" mode="smaller-2x">
            <TextBox name ='container-status-update-CNTR' disabled value={mbl.emptyRtnName ?? ''} />
          </InlineInputControlRow>}

          {!isOtherShipment && <InlineInputControlRow label="Pickup #" mode="smaller-2x">
            <TextBox name ='container-status-update-pickupNo' value={pickupNo} disabled />
          </InlineInputControlRow>}
        </div>
      </div>

      <div style={{marginTop: '10px'}}>
        <BlueTitleRow title={<span style={{paddingLeft: '14px'}}>Container Status</span>} />
      </div>

      <MblMilestoneContainerStatus
        isView={isView}
        selectedIndex={selectedIndex}
        //[save-sqlinfo]status={selectedIndex >= 0 && selectedIndex < containerInfo.lineItems.length ? containerInfo.lineItems[selectedIndex].milestone.status : null}
        status={selectedIndex >= 0 && selectedIndex < containerInfo.length ? mbl.milestone?.eventItemList?.filter(v => v.cntrNo === containerInfo[selectedIndex].containerNo || (v.pimsCntrId > 0 && v.pimsCntrId === containerInfo[selectedIndex].pimsLinkId))??null : null}
        applyToAll={applyContainerStatusToAll}
        onChange={onContainerStatusChange}
        //[save-sqlinfo]defaultStatus={containerInfo.lineItems.length > 0 ? containerInfo.lineItems[0].milestone.status : null}
        //defaultStatus={containerInfo.length > 0 ? mbl.milestone?.eventItemList?.filter(v => v.cntrNo === containerInfo[0].containerNo || (v.pimsCntrId > 0 && v.pimsCntrId === containerInfo[0].pimsLinkId))??null : null}
        mbl={mbl}
      />
    </div>
  );
};

const MblMilestone = React.forwardRef(MblMilestoneImpl);

export default React.memo(MblMilestone);
